import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { KeyOf } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import * as ICON_LIST from '~/assets/img/icons';
import Bubble from './Bubble/Bubble';
import Menu from './Menu/Menu';
import * as S from './Navigation.styled';

export type NavigationMenu = {
  title: string;
  icon: KeyOf<typeof ICON_LIST>;
  activeIcon: KeyOf<typeof ICON_LIST>;
  url: string;
};

export const navigationArr: NavigationMenu[] = [
  {
    title: 'Home',
    icon: 'Home',
    activeIcon: 'HomeActive',
    url: PAGE_ROUTE.MAIN,
  },
  {
    title: 'Chat',
    icon: 'Chat',
    activeIcon: 'ChatActive',
    url: PAGE_ROUTE.CHAT_LIST,
  },
  {
    title: 'Character',
    icon: 'MyPage',
    activeIcon: 'MyPage',
    url: PAGE_ROUTE.CREATE_NEW_CHARACTER,
  },
  {
    title: 'Group chat',
    icon: 'Chat',
    activeIcon: 'Chat',
    url: PAGE_ROUTE.CREATE_GROUP_CHAT,
  },
  {
    title: 'Explore',
    icon: 'Explore',
    activeIcon: 'ExploreActive',
    url: PAGE_ROUTE.EXPLORE,
  },
  {
    title: 'My',
    icon: 'MyPage',
    activeIcon: 'MyPageActive',
    url: PAGE_ROUTE.MYPAGE,
  },
];

export default function NavigationChat() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const isActive = (menuUrl: string) => pathname === menuUrl;
  const centerButtonRef = useRef<HTMLDivElement>(null);

  const onClickMenu = (menuUrl: string) => {
    if (isActive(menuUrl)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(menuUrl);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        centerButtonRef.current &&
        !centerButtonRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [centerButtonRef]);

  return (
    <S.Container>
      <S.Wrapper>
        <S.MenuWrapper>
          {navigationArr.slice(0, 2).map((menu, idx) => (
            <S.MenuBox
              key={`ChatNavigation_${idx}`}
              onClick={() => onClickMenu(menu.url)}
              className={isActive(menu.url) ? 'active' : ''}
            >
              <Menu menu={menu} isActive={isActive(menu.url)} />
            </S.MenuBox>
          ))}
        </S.MenuWrapper>

        <S.CenterButtonBox ref={centerButtonRef}>
          <S.CenterButton isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
            center button
          </S.CenterButton>

          <Bubble isOpen={isOpen} />
        </S.CenterButtonBox>

        <S.MenuWrapper>
          {navigationArr.slice(4, 6).map((menu, idx) => (
            <S.MenuBox
              key={`ChatNavigation_${idx}`}
              onClick={() => onClickMenu(menu.url)}
              className={isActive(menu.url) ? 'active' : ''}
            >
              <Menu menu={menu} isActive={isActive(menu.url)} />
            </S.MenuBox>
          ))}
        </S.MenuWrapper>
      </S.Wrapper>
    </S.Container>
  );
}
